package cc.bluepeak.clubmanager.site.components.layouts

import androidx.compose.runtime.Composable
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.styles.DropDownStyle
import cc.bluepeak.clubmanager.site.styles.PaddedCardStyle
import cc.bluepeak.clubmanager.site.styles.Theme
import com.varabyte.kobweb.compose.dom.svg.Rect
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.gridRow
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select

@Composable
fun Footer() {
    Box(PageStyle.toModifier().gridRow(2)) {
        Row(
            PaddedCardStyle.toModifier().fillMaxWidth().gap(.5.cssRem),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Column(Modifier.gap(1.cssRem)) {
                Svg(Modifier.height(5.px).width(150.px).toAttrs()) {
                    Rect {
                        width(50)
                        height(5)
                        fill(Colors.Red)
                    }
                    Rect {
                        x(50)
                        width(50)
                        height(5)
                        fill(Theme.lightBackground)
                    }
                    Rect {
                        x(100)
                        width(50)
                        height(5)
                        fill(Colors.Red)
                    }
                }
                SpanText(Res.string.copyright, Modifier.color(Theme.secondary.copyf(alpha = 0.5f)))
            }
            Select(DropDownStyle.toModifier().toAttrs() {
                onChange {
                    window.location.href =
                        window.location.href.replace("/${Res.string.locale}/", "/${it.target.value}/")
                }
            }) {
                Res.locales.forEach {
                    Option(it.value, {
                        if (Res.string.locale == it.value) selected()
                    }) {
                        Row {
                            SpanText(it.native)
                        }
                    }
                }
            }
        }
    }
}